import React from 'react';
import { default as moment, Moment } from 'moment';
import {
    Card,
    CardActionArea,
    CardContent,
    Grid2 as Grid,
    ListItemText,
    Menu,
    List,
    ListItemButton,
    CardActionAreaProps,
} from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/styles';

interface Props {
    readonly styled: StyledProps;
    readonly onFilter: (start: Moment, end: Moment) => void;
    readonly start: Moment;
    readonly end: Moment;
}

interface State {
    readonly anchorEl: HTMLElement | undefined;
}

export class ReportFilterDates extends React.Component<Props, State> {
    state: State = {
        anchorEl: undefined,
    };

    render() {
        const { onFilter, start, end } = this.props;
        const { anchorEl } = this.state;
        const handleMenu = (event: any) => this.setState({ anchorEl: event.currentTarget });
        const closeMenu = () => this.setState({ anchorEl: undefined });

        const onCancelButton = () => {
            closeMenu();
        };

        let now = moment.utc();

        const definedRanges = [
            {
                startDate: now.clone().subtract(1, 'day'),
                endDate: now.clone(),
                label: 'Yesterday',
            },
            {
                startDate: now.clone().subtract(7, 'days'),
                endDate: now.clone(),
                label: 'Last 7 days',
            },
            {
                startDate: now.clone().subtract(14, 'days'),
                endDate: now.clone(),
                label: 'Last 14 days',
            },
            {
                startDate: now.clone().subtract(28, 'days'),
                endDate: now.clone(),
                label: 'Last 28 days',
            },
            {
                startDate: now.clone().subtract(30, 'days'),
                endDate: now.clone(),
                label: 'Last 30 days',
            },
            {
                startDate: now.clone().subtract(60, 'days'),
                endDate: now.clone(),
                label: 'Last 60 days',
            },
            {
                startDate: now.clone().subtract(90, 'days'),
                endDate: now.clone(),
                label: 'Last 90 days',
            },
        ];

        const open = !!anchorEl;
        const setDateRange = (dateRange: any) => {
            closeMenu();
            onFilter(dateRange.startDate, dateRange.endDate);
        };

        const selected = definedRanges.find(s => s.startDate.format('YYYY-MM-DD') === start.format('YYYY-MM-DD')
            && s.endDate.format('YYYY-MM-DD') === end.format('YYYY-MM-DD'))
        const label = selected ? selected.label : 'Custom';

        return (
            <>
                <CardStyled>
                    <CardActionAreaStyles styled={this.props.styled} onClick={handleMenu}>
                        <CardContentStyles>
                            <Grid container={true} spacing={0} style={{ margin: `auto`}}>
                                <Grid size={12} style={{ fontSize: 12, lineHeight: '16px' }}>
                                    {label}
                                </Grid>
                            </Grid>
                            <ArrowDropDown style={{ margin: `auto`, color: 'inherit'}}/>
                        </CardContentStyles>
                    </CardActionAreaStyles>
                </CardStyled>
                <MainMenu
                    id={`filter`}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={open}
                    onClose={onCancelButton}
                    style={{
                        marginTop: 2,
                    }}
                >

                    <MainList>
                        {definedRanges.map((dateRange, index) => {
                            const handleListItemClick = () => {
                                setDateRange(dateRange);
                            }
                            return (
                                <MainListItem
                                    key={`date_range_list_item_${index}`}
                                    selected={selected ? selected === dateRange: false}
                                    onClick={handleListItemClick}
                                >
                                    <ListItemText primary={dateRange.label} />
                                </MainListItem>
                            );
                        })}
                    </MainList>
                </MainMenu>
            </>
        );
    }
}

const MainMenu = styled(Menu)(({
    '& .MuiMenu-list': {
        padding: 0,
    },
}));

const CardStyled = styled(Card)(({
    '&.MuiCard-root': {
        margin: 0,
        border: 'none',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        maxWidth: 130,
        color: 'inherit',
        padding: '0px 0px 10px 0px',
    },
}));

const CardContentStyles = styled(CardContent)(({
    '&.MuiCardContent-root': {
        padding: '0px 10px',
        display: 'flex',
        justifyContent: 'flex-end',
        color: 'inherit',
    },
}));

interface StyledCardActionAreaProps extends CardActionAreaProps {
    styled: StyledProps;
}
const CardActionAreaStyles = styled((props: StyledCardActionAreaProps) => (
    <CardActionArea
        {...props}
        sx={{
            '&.MuiCardActionArea-root': {
                "&$selected": {
                    backgroundColor: 'transparent',
                    color: props.styled.themeMode === 'light' ? '#7cacf8' : '#7cacf8',
                },
                "&:disabled": {
                    backgroundColor: props.styled.themeMode === 'light' ? '#fafafa' : '#0f1214',
                    color: 'rgb(0, 112, 201)',
                },
                "&:hover": {
                    backgroundColor: props.styled.themeMode === 'light' ? '#fafafa' : '#0f1214',
                    color: props.styled.themeMode === 'light' ? '#7cacf8' : '#7cacf8',
                },
            },
        }}
    />
))(() => ({}));

const MainList = styled(List)(({
    '&.MuiList-root': {
        minWidth: 200,
        padding: '14px 0',
    },
}));

const MainListItem = styled(ListItemButton)(({
    '&.MuiListItemButton-root': {
        padding: '0px 4px 0px 16px',
        height: 32,
        "&$selected": {
            backgroundColor: '#e7effd',
            "&:disabled": {
                backgroundColor: 'rgba(0, 0, 0, 0.08)'
            },
            "&:hover": {
                backgroundColor: 'rgba(0, 0, 0, 0.08)'
            },
        }
    },
    '&.Mui-selected': {
        backgroundColor: '#e7effd',
        '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
    },
}));
